var songlist = {
	beforeSongTime: "",
	beforeChannelTime: "",
	init: function(){
		if( !$("main").hasClass("yesterday") ){
			songlist.loadNowPlaying();
		}
		
		songlist.nav();
	},
	loadNowPlaying: function(){
		let onplayingURL = "/top/xml/now_on_air_song_v2.xml";
		let params = {};
		let $currentSong;
		common.getXML(onplayingURL, params).done(function(data){
			let $data = $(data);
			//console.log($data.find("now_on_air_song"));
			$data.find("now_on_air_song").each(function(i){
				//1つ目が今流れている曲
				if(i === 0){
					$currentSong = $(this);
				}
			});
			var d = new Date();
			let y = d.getFullYear();
			let m = d.getMonth() + 1;
			let day = d.getDate();
			let time = y + " / " + ( '00' + m ).slice( -2 ) + " / " + ( '00' + day ).slice( -2 );
			$("#block_nowplaying p.time span").eq(0).html(time);
			let info = $currentSong.find("data").attr("information");
			let infoArry = info.match(/「(.*)」\s*(.*)?\s([0-9]{1,2}:[0-9]{1,2})\s*$/);
			if(infoArry[3] != songlist.beforeSongTime){
				$("#block_nowplaying h4").html(infoArry[1]);
				$("#block_nowplaying p.txt_artist span").html(infoArry[2]);
				let img = $currentSong.find("data").attr("amazon_img");
				if(img === ""){
					img = "/assets_v2020/images/songlist/noimg.jpg";
				}
				$("#block_nowplaying .img figure").css("background-image", "url(" + img + ")");
				let amazonURL = $currentSong.find("data").attr("amazon_url");
				let cdURL 		= $currentSong.find("data").attr("cd_url");
				//console.log(amazonURL, cdURL)
				let clipID = $currentSong.find("data").attr("clip_id");
				$("#block_nowplaying ul.btn_info a.btn_clip").attr("id", clipID);
				//console.log(clipID)
				if(amazonURL != ""){
					$("#block_nowplaying .block_buy li").eq(1).removeClass("disable");
					$("#block_nowplaying .btn_buy_pc li").eq(1).removeClass("disable");
					$("#block_nowplaying .block_buy li").eq(1).find("a").attr("href", amazonURL);
					$("#block_nowplaying .btn_buy_pc li").eq(1).find("a").attr("href", amazonURL);
				}else{
					$("#block_nowplaying .block_buy li").eq(1).addClass("disable");
					$("#block_nowplaying .btn_buy_pc li").eq(1).addClass("disable");
				}
				//console.log(cdURL)
				if(cdURL != ""){
					$("#block_nowplaying .block_buy ul li").eq(0).removeClass("disable");
					$("#block_nowplaying .btn_buy_pc ul li").eq(0).removeClass("disable");
					$("#block_nowplaying .block_buy ul li").eq(0).find("a").attr("href", amazonURL);
					$("#block_nowplaying .btn_buy_pc ul li").eq(0).find("a").attr("href", amazonURL);
					$("#block_nowplaying .btn_cd a").attr("href", cdURL);
				}else{
					$("#block_nowplaying .block_buy ul li").eq(0).addClass("disable");
					$("#block_nowplaying .btn_buy_pc ul li").eq(0).addClass("disable");
				}
			}
			songlist.beforeSongTime = infoArry[3];
			common.activeClip();
		});
	},
	nav: function(){
		$("a.btn_open_search").off().on("click", function(){
			$("#search_songs").toggleClass("active");
			$(".search_song_content").animate({
				height: "toggle", "opacity": "toggle"
			},300);
		});
		$("a.btn_buy").off().on("click", function(){
			let idx = $("a.btn_buy").index(this);
			$(".block_buy").eq(idx).find(".buy_inner").animate({
				height: "toggle", "opacity": "toggle"
			},300);
		});
	}
}